import responsiveConfig from './responsiveConfig'

export default {
    ...responsiveConfig,
    supportsUsingPresetVariants: true,
    modulesList: responsiveConfig.modulesList.concat(['appStudioPublicAPI'])
}
